import React, { FC } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { Modal } from '../modal'
import { Row } from '../row'
import { Button } from '../button'
import { Column } from '../column'

import { useStyle } from './question-modal.styles'
import { QuestionModalProps } from './question-modal.types'

export const QuestionModal: FC<QuestionModalProps> = ({
  className = '',
  classNameContainer = '',
  title,
  titleTx,
  disabled,
  children,
  cancelText = 'Cancel',
  cancelTx = 'question.modal.cancel',
  successText = 'Ok',
  successTx = 'question.modal.ok',
  onClose,
  onCancel,
  onSubmit
}) => {
  const classes = useStyle()
  const justify = isMobileOnly ? 'space-between' : 'flex-end'

  return (
    <Modal
      className={classNameContainer}
      title={title}
      titleTx={titleTx}
      onClose={onClose}
    >
      <Column
        fullWidth
        className={`${className} ${classes.details}`}
        justifyContent="flex-start"
      >
        {children}
      </Column>
      <Row fullWidth className={classes.bottom} justifyContent={justify}>
        <Button
          className={classes.success}
          color="yellow"
          preset="secondaryBorderMedium"
          textColor="yellow"
          textPreset="maxButton"
          text={cancelText}
          tx={cancelTx}
          onClick={onCancel || onClose}
        />
        <Button
          className={classes.confirm}
          color="yellow"
          disabled={disabled}
          preset="secondaryMedium"
          textColor="white"
          textPreset="maxButton"
          text={successText}
          tx={successTx}
          onClick={onSubmit}
        />
      </Row>
    </Modal>
  )
}
